/**
 * Orquestra replay ordenado por sessão e sequência.
 */

import type { QueueItem } from '../queue';
import { sortQueueForReplay } from '../ordering/orderedFlush';
import { canBatchTogether } from '../ordering/transactionGroup';
import { recordReplayBatch } from '../telemetry';

const DEFAULT_MAX_BATCH = 10;
const DEFAULT_MAX_BYTES = 60_000;

export interface ReplayBatchPlan {
  batches: QueueItem[][];
}

export function planReplayBatches(
  items: QueueItem[],
  maxBatch = DEFAULT_MAX_BATCH,
  maxBytes = DEFAULT_MAX_BYTES
): ReplayBatchPlan {
  const sorted = sortQueueForReplay(items);
  const batches: QueueItem[][] = [];
  let current: QueueItem[] = [];
  let bytes = 0;

  for (const item of sorted) {
    if (item.params.type === 'PAGE_VIEW') continue;
    if (
      current.length > 0 &&
      !canBatchTogether(current[current.length - 1], item)
    ) {
      if (current.length > 0) {
        batches.push(current);
        recordReplayBatch();
      }
      current = [];
      bytes = 0;
    }
    const est = new TextEncoder().encode(
      JSON.stringify(item.params.eventData ?? {})
    ).length;
    if (
      current.length >= maxBatch ||
      (current.length > 0 && bytes + est > maxBytes)
    ) {
      batches.push(current);
      recordReplayBatch();
      current = [];
      bytes = 0;
    }
    current.push(item);
    bytes += est;
  }
  if (current.length > 0) {
    batches.push(current);
    recordReplayBatch();
  }
  return { batches };
}

export function flattenReplayPlan(plan: ReplayBatchPlan): QueueItem[] {
  return plan.batches.flat();
}
